import React, {useState} from 'react'
import $ from "jquery"
import ConfirmPopup from '../../Popup/ConfirmandProceed'


const Next = (props) => {
    const [popupOpen, setPopupOpen] = useState(false)
    const getMagentoDetails = () => {
        var fieldsLength = $("#magento_setup .magentoGroup").length
        var magentoDetailsLength = props.magentoDetails.length
        if(magentoDetailsLength === 0){
            $(".magento_version-field").addClass("errorStateSelect")
        }else if(fieldsLength === props.magentoDetails.length){
            localStorage.setItem("awsDetails", JSON.stringify(props.awsDetails))
            localStorage.setItem("magentoDetails", JSON.stringify(props.magentoDetails))
            localStorage.setItem("fullName", props.name)
            localStorage.setItem("sourceName", props.sourceName)
            localStorage.setItem("targetName", props.targetName)
            localStorage.setItem("connectorInfo", JSON.stringify(props.connectorInfo))
            localStorage.setItem("instance", props.instance)
            localStorage.setItem("id", props.id)
            setPopupOpen(true)
        }
    }
    const getCancel = (cancelPopup) =>{
        setPopupOpen(cancelPopup)
    }
    return (
        <>
            <div className='row'>
                <div className="col-lg-12 float-right">
                    <button type='button' id="magentoSubmitnew" className="btn btn-primary btn-rounded waves-effect waves-light float-right magentonext" onClick={getMagentoDetails}>
                        Next 1
                    </button>
                </div>
            </div>
            {
                popupOpen ? 
                    <ConfirmPopup
                        getCancel={getCancel} 
                        awsDetails={props.awsDetails} 
                        magentoDetails={props.magentoDetails} 
                        name={props.name}
                        sourceName={props.sourceName}
                        targetName={props.targetName} 
                        connectorInfo={props.connectorInfo} 
                        instance = {props.instance}
                        id={props.id}
                        productTypeValue = {props.productTypeValue}
                        eventValue= { props.eventValue}
                        sourceVersion = {props.sourceVersion}
                        targetVersion ={props.targetVersion}
                        versionId ={props.versionId }
                    />
                : null
            }
        </>
    )
}
export default Next